import { render, staticRenderFns } from "./RadioToggleButton.vue?vue&type=template&id=477623ec&scoped=true&"
import script from "./RadioToggleButton.vue?vue&type=script&lang=ts&"
export * from "./RadioToggleButton.vue?vue&type=script&lang=ts&"
import style0 from "./RadioToggleButton.vue?vue&type=style&index=0&id=477623ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477623ec",
  null
  
)

export default component.exports